import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Category from "@/pages/Category";
import Recipe from "@/pages/Recipe";
import Shop from "@/pages/Shop";
import Navigation from "@/components/Navigation";
import LenisProvider from "@/components/LenisProvider";
import { Toaster } from "@/components/ui/sonner";
import { ServingsProvider } from "@/context/ServingsContext";
import "@/App.css";

function App() {
  useEffect(() => {
    // Warm up seed endpoint (idempotent, non-blocking)
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/seed`, { method: "POST" }).catch(() => {});
  }, []);

  return (
    <BrowserRouter>
      <LenisProvider>
        <ServingsProvider>
          <Navigation />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/category/:category" element={<Category />} />
            <Route path="/recipe/:slug" element={<Recipe />} />
            <Route path="/shop" element={<Shop />} />
          </Routes>
          <Toaster position="bottom-center" />
        </ServingsProvider>
      </LenisProvider>
    </BrowserRouter>
  );
}

export default App;
